import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetAccountProjectCountQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
  page: Types.PageInput;
  projectStatus?: Types.InputMaybe<Array<Types.ProjectStatusInput>>;
  storageTypes?: Types.InputMaybe<Array<Types.MountedStorageStatus>>;
}>;


export type GetAccountProjectCountQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, projects: { __typename?: 'ProjectConnection', totalCount: number } } | null };


export const GetAccountProjectCount = /*#__PURE__*/ gql`
    query GetAccountProjectCount($accountId: ID!, $page: PageInput!, $projectStatus: [ProjectStatusInput!], $storageTypes: [MountedStorageStatus!]) {
  account(accountId: $accountId) {
    id
    projects(
      page: $page
      filter: {projectStatus: $projectStatus, storageTypes: $storageTypes}
    ) {
      totalCount
    }
  }
}
    ` as unknown as DocumentNode<GetAccountProjectCountQuery, GetAccountProjectCountQueryVariables>;

          

          export const useGetAccountProjectCountQuery = (options?:QueryHookOptions<GetAccountProjectCountQuery, GetAccountProjectCountQueryVariables>) => useQuery(GetAccountProjectCount, options);

          

          export type GetAccountProjectCountQueryOptions = QueryHookOptions<GetAccountProjectCountQuery, GetAccountProjectCountQueryVariables>;

          

          export const useGetAccountProjectCountLazyQuery = (options?:LazyQueryHookOptions<GetAccountProjectCountQuery, GetAccountProjectCountQueryVariables>) => useLazyQuery(GetAccountProjectCount, options);

          

          export type GetAccountProjectCountQueryResult = ReturnType<typeof useGetAccountProjectCountQuery>;

          
